import React, { createContext, useContext, useState, ReactNode } from 'react';

type SelectedRowsContextValue<T> = [
  T[],
  React.Dispatch<React.SetStateAction<T[]>>
];

function createSelectedRowsContext<T>() {
  return createContext<SelectedRowsContextValue<T>>([[], () => {}]);
}

const SelectedRowsContext = createSelectedRowsContext<any>();

export const useSelectedRows = <T,>() =>
  useContext<SelectedRowsContextValue<T>>(SelectedRowsContext);

interface SelectedRowsProviderProps<T> {
  children: ReactNode;
  initialRows?: T[];
}
export const SelectedRowsProvider = <T,>({
  children,
  initialRows = [],
}: SelectedRowsProviderProps<T>) => {
  const [selectedRows, setSelectedRows] = useState<T[]>(initialRows);

  return (
    <SelectedRowsContext.Provider value={[selectedRows, setSelectedRows]}>
      {children}
    </SelectedRowsContext.Provider>
  );
};
